import { ACTIONS } from "../actions/CustomPage";

const initialState = {
  currentPage: null,
  currentLanguage: "ug",
  selectedBlockId: null,
  loading: false,
  errors: {},
};

export const customPage = (state = initialState, action = {}) => {
  switch (action.type) {
    case ACTIONS.SET_CURRENT_PAGE: {
      return {
        ...state,
        currentPage: action.page,
        selectedBlockId: null,
      };
    }
    case ACTIONS.SET_CURRENT_LANGUAGE: {
      return {
        ...state,
        currentLanguage: action.language,
      };
    }
    case ACTIONS.SET_SELECTED_BLOCK: {
      return {
        ...state,
        selectedBlockId: action.blockId,
      };
    }
    case ACTIONS.ADD_BLOCK: {
      if (!state.currentPage) return state;
      const newBlocks = [...(state.currentPage.layout_data || [])];
      newBlocks.push(action.block);
      return {
        ...state,
        currentPage: {
          ...state.currentPage,
          layout_data: newBlocks,
        },
        selectedBlockId: action.block.id,
      };
    }
    case ACTIONS.UPDATE_BLOCK: {
      if (!state.currentPage) return state;
      const updatedBlocks = state.currentPage.layout_data.map((block) => {
        if (block.id === action.blockId) {
          return {
            ...block,
            config: {
              ...block.config,
              ...action.config,
            },
          };
        }
        return block;
      });
      return {
        ...state,
        currentPage: {
          ...state.currentPage,
          layout_data: updatedBlocks,
        },
      };
    }
    case ACTIONS.REMOVE_BLOCK: {
      if (!state.currentPage) return state;
      const filteredBlocks = state.currentPage.layout_data.filter(
        (block) => block.id !== action.blockId
      );
      return {
        ...state,
        currentPage: {
          ...state.currentPage,
          layout_data: filteredBlocks,
        },
        selectedBlockId: null,
      };
    }
    case ACTIONS.UPDATE_BLOCK_ORDER: {
      if (!state.currentPage) return state;
      // Recalculate order values
      const orderedBlocks = action.blocks.map((block, index) => ({
        ...block,
        order: index,
      }));
      return {
        ...state,
        currentPage: {
          ...state.currentPage,
          layout_data: orderedBlocks,
        },
      };
    }
    case ACTIONS.RESET_CURRENT_PAGE: {
      return initialState;
    }
    default: {
      return state;
    }
  }
};

export const getCurrentPage = (state) => {
  return state.customPage?.currentPage;
};

export const getCurrentLanguage = (state) => {
  return state.customPage?.currentLanguage || "ug";
};

export const getSelectedBlock = (state) => {
  const selectedBlockId = state.customPage?.selectedBlockId;
  if (!selectedBlockId || !state.customPage?.currentPage) return null;
  return state.customPage.currentPage.layout_data?.find(
    (block) => block.id === selectedBlockId
  );
};

export const getBlocks = (state) => {
  if (!state.customPage?.currentPage) return [];
  return [...(state.customPage.currentPage.layout_data || [])].sort(
    (a, b) => a.order - b.order
  );
};


